import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MessageCircle, MapPin } from "lucide-react";
import { useLang } from "../i18n";
import { IMAGES, CONTACT } from "../lib/data";

export const Footer = () => {
  const { t } = useLang();
  const year = new Date().getFullYear();

  const links = [
    { to: "/", key: "nav.home" },
    { to: "/services", key: "nav.services" },
    { to: "/fleet", key: "nav.fleet" },
    { to: "/destinations", key: "nav.destinations" },
    { to: "/about", key: "nav.about" },
    { to: "/contacts", key: "nav.contacts" },
    { to: "/booking", key: "nav.booking" },
  ];

  return (
    <footer data-testid="main-footer" className="relative z-10 border-t border-white/10 bg-matte-deep">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-20 md:grid-cols-3 lg:px-8">
        <div>
          <img src={IMAGES.logo} alt="NC&C Luxury" className="h-14 w-auto object-contain" />
          <p className="mt-6 max-w-xs font-body text-sm leading-relaxed text-white/50">{t("footer.tagline")}</p>
        </div>

        <div>
          <h4 className="font-body text-xs uppercase tracking-[0.2em] text-gold">{t("footer.quickLinks")}</h4>
          <ul className="mt-6 space-y-3">
            {links.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="font-body text-sm text-white/60 transition-colors hover:text-white">
                  {t(l.key)}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-body text-xs uppercase tracking-[0.2em] text-gold">{t("footer.contactInfo")}</h4>
          <ul className="mt-6 space-y-4 font-body text-sm text-white/60">
            <li><a href={`tel:${CONTACT.phone}`} className="flex items-center gap-3 hover:text-white"><Phone size={16} className="text-gold" /> {CONTACT.phoneIntl}</a></li>
            <li><a href={`https://wa.me/${CONTACT.whatsapp}`} target="_blank" rel="noreferrer" className="flex items-center gap-3 hover:text-white"><MessageCircle size={16} className="text-gold" /> WhatsApp</a></li>
            <li><a href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 hover:text-white"><Mail size={16} className="text-gold" /> {CONTACT.email}</a></li>
            <li className="flex items-start gap-3"><MapPin size={16} className="mt-0.5 shrink-0 text-gold" /> {CONTACT.address}</li>
          </ul>
          <p className="mt-6 font-body text-sm text-white/40">{t("footer.followText")}</p>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-5 py-6 font-body text-xs text-white/40 md:flex-row lg:px-8">
          <span>© {year} NC&C Luxury · P.IVA {CONTACT.vat} · {t("footer.rights")}</span>
          <div className="flex items-center gap-4">
            <Link to="/privacy" data-testid="footer-privacy" className="transition-colors hover:text-gold">{t("footer.privacy")}</Link>
            <span>Napoli · Costiera Amalfitana · Sorrento · Capri</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
